var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1666 3.41667V5.25C17.1666 5.91667 16.7499 6.75 16.3333 7.16667L12.7499 10.3333C12.2499 10.75 11.9166 11.5833 11.9166 12.25V15.8333C11.9166 16.3333 11.5833 17 11.1666 17.25L9.99995 18C8.91661 18.6667 7.41661 17.9167 7.41661 16.5833V12.1667C7.41661 11.5833 7.08328 10.8333 6.74995 10.4167L6.35828 10.0083C6.09995 9.73333 6.04995 9.31667 6.25828 8.99167L10.5249 2.14167C10.6749 1.9 10.9416 1.75 11.2333 1.75H15.4999C16.4166 1.75 17.1666 2.5 17.1666 3.41667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62504 3.025L5.66671 7.76667C5.38337 8.225 4.73337 8.29167 4.35837 7.9L3.58337 7.08333C3.16671 6.66667 2.83337 5.91667 2.83337 5.41667V3.5C2.83337 2.5 3.58337 1.75 4.50004 1.75H7.91671C8.56671 1.75 8.96671 2.46667 8.62504 3.025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9f8d552d8a4dee1f500107a4b6e8ef57.svg";
export { ForwardRef as ReactComponent };